module.exports = __webpack_public_path__ + "static/fonts/Mont-Regular.0dc4745.woff2";